import { useState, useEffect } from "react";
import { request } from "../functions/apiRequestHelper";
import API from '../functions/api';
import Select from "../audi-ui-components/Select";

const MakeModule = ({ values, errors, touched, name = "currentModel", title, label, setFieldValue, setFieldTouched, theme }) => {

    const defaultOpts = [
        {label: "Audi", value: "audi"},
        {label: "BMW", value: "bmw"},
        {label: "Volkswagen", value: "volkswagen"},
        {label: "Mercedes Benz", value: "mercedes-benz"},
    ];

    const [loading, setLoading] = useState(true);
    const [makeOpts, setMakeOpts] = useState(defaultOpts);

    useEffect(() => {
        setTimeout(()=>{ setFieldValue(name, ""); }, 200);
        API.post(`${process.env.RAZZLE_GQLAPI}`, {
            query: /* GraphQL */`query ($skip: Int, $take: Int) {
            makersList(skip: $skip, take: $take) {
                items {
                    value
                    label: name
                }
                totalCount
            }
            }`,
            variables: {
                skip: 0,
                take: 50,
            }
        }).then((response) => {
            // console.log(response);
            if (response.data?.data?.makersList) {
                let opts = [...defaultOpts];
                opts.push({label: "──────────", value: "_", disabled: true});
                opts = opts.concat(response.data.data.makersList.items);
                setMakeOpts(opts);
                setLoading(false);
            }
        }).catch((error) => {
            // console.error(error);
            setLoading(false);
        });
    }, []);

    return (
        <div className="model-module form-module">
            {title && <p className="aui-headline-5 mb-2">{title}</p>}
            <Select name={name}
                label={label}
                options={makeOpts}
                value={values[name] || ""}
                onChange={(v) => { setFieldValue(name, v); }}
                onBlur={() => { setFieldTouched(name); }}
                isInvalid={errors[name] && touched[name]}
                invalidMessage={errors[name]}
                description={loading ? "Loading more brands..." : ""}
                theme={theme === "dark" ? "light" : null}
            />
        </div>
    );
}

export default MakeModule;
